import { cn } from '../../lib/utils';

interface Props {
  className?: string;
}

function MembershipCardSkeleton({ className }: Readonly<Props>) {
  return (
    <div className={cn('w-full', className)}>
      <div className="relative animate-pulse overflow-hidden rounded-2xl bg-white px-4 pl-8 shadow-lg drop-shadow-lg">
        {/* Left gradient bar skeleton */}
        <div className="absolute left-0 top-0 h-full w-8 bg-gray-200">
          <div className="flex h-full rotate-180 items-center justify-center">
            <div className="h-16 w-3 rounded bg-gray-300"></div>
          </div>
        </div>

        {/* Main content skeleton */}
        <div className="relative w-full pb-1 pl-2 pt-6">
          <div className="z-20 space-y-4">
            {/* Title skeleton */}
            <div className="flex flex-1 items-center justify-between">
              <div className="flex flex-1 flex-col gap-1">
                <div className="h-5 w-48 rounded bg-gray-200"></div>
              </div>
              {/* Points badge skeleton */}
              <div className="flex min-w-20 items-center justify-center rounded-lg bg-gray-100 p-1 px-2">
                <div className="h-4 w-12 rounded bg-gray-200"></div>
                <div className="ml-1 size-6 rounded-full bg-gray-200"></div>
              </div>
            </div>

            <div className="">
              <div className="relative z-20 flex flex-wrap items-center gap-2">
                {/* Progress bar skeleton */}
                <div className="w-[65%]">
                  <div className="h-3 w-full overflow-hidden rounded-full bg-gray-200">
                    <div className="h-full w-1/2 rounded-full bg-gray-300"></div>
                  </div>
                </div>
                <div className="h-3 w-16 rounded bg-gray-200"></div>
              </div>

              {/* Description skeleton */}
              <div className="mt-3 space-y-1">
                <div className="h-3 w-3/4 rounded bg-gray-200"></div>
                <div className="h-3 w-1/2 rounded bg-gray-200"></div>
              </div>
            </div>

            {/* Available points skeleton */}
            <div className="bottom-2 right-2 z-10 space-y-1 text-sm">
              <div className="flex items-center justify-end gap-2">
                <div className="h-4 w-24 rounded bg-gray-200"></div>
                <div className="h-4 w-8 rounded bg-gray-200"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MembershipCardSkeleton;
